import React from "react";
import { useInView } from "react-intersection-observer";

import { ResultListHitComponentProps } from "@components/Search/SearchResults/StateComponents/ResultList/resultList.container";

import { ContentPageAlgoliaModel } from "../../../../../../@types/service/product/algolia/contentPage.algolia.model";
import "./contentResultListHit.scss";

type ContentResultListHitComponentProps =
    ResultListHitComponentProps<ContentPageAlgoliaModel>;

const ContentResultListHitComponent = ({
    hit,
}: ContentResultListHitComponentProps) => {
    const trackContentTile = (inView: boolean) => {
        if (inView) {
            // TODO: gaan we dit volgen
        }
    };

    const { ref: invViewRef } = useInView({
        triggerOnce: true,
        onChange: trackContentTile,
    });
    return (
        <article className={"contentResultListHit card--all"} ref={invViewRef}>
            <a
                href={hit.externalPath}
                rel={"bookmark"}
                className={"text-reset text-decoration-none"}
            >
                {hit.image && (
                    <img
                        className={"image-component"}
                        src={hit.image}
                        alt={hit.title}
                        data-sizes="auto"
                        data-src={hit.image}
                    />
                )}
                <h5 className={"text-primary clamp-2"}>{hit.title}</h5>
                <p className="clamp-4">{hit.description}</p>
            </a>
        </article>
    );
};

export { ContentResultListHitComponent };
